<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-row type="flex" justify="left">
      <el-col :span="20">
        <el-button @click="jumpImportOffline"><i class="el-icon-upload2" />导入订单</el-button>

        <el-select v-model="status" placeholder="状态筛选" clearable style="width:150px">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-col>
      <el-col :span="4">
        <span class="text item">
          <el-popconfirm title="确认无误，开始导入？" @confirm="onSubmitOrders()">
            <el-button type="primary" slot="reference"><i class="el-icon-s-promotion" /> 确认导入</el-button>
          </el-popconfirm>
        </span>
      </el-col>
    </el-row>

    <el-divider content-position="left">订单信息</el-divider>
    <el-alert title="导入数据存放于浏览器本地，清理浏览器缓存将会丢失！" type="warning" effect="dark" :closable="false" />
    <el-alert title="重复检测只会导入时检测，点击有蓝色下划线的单元格可以修改信息，修改后会实时解析。" type="warning" :closable="false" />
    <!-- 日期	快递公司	快递单号	姓名	产品信息	收货地址	是否上传线下订单 -->

    <el-table :data="imports" resource="imports">
      <el-table-column prop="num" label="序号" width="50" align="center" />
      <el-table-column prop="order_time" label="日期" width="90" />
      <el-table-column prop="express_company_name" label="快递公司" width="80" />
      <el-table-column prop="express_no" label="快递单号" width="140" />
      <el-table-column prop="order_items" label="产品信息">
        <template #default="{ row }">
          <input-edit v-if="row.status != 6" :id="row.num" :update="updateImportItemRow" field="order_items" v-model="row.order_items" />
          <span v-else>{{ row.order_items }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ship_addr" label="收货地址">
        <template #default="{ row }">
          <input-edit v-if="row.status != 6" :id="row.num" :update="updateImportShipRow" field="ship_addr" v-model="row.ship_addr" />
          <span v-else>{{ row.ship_addr }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="备注" width="100" />
      <el-table-column prop="status" label="状态" width="130">
        <template #default="{ row }">
          <!-- 1 待处理 2 重复数据 3 商品解析异常 4 地址解析异常 5 上传中 6 上传成功 7 上传失败 8 数据不完整 9 快递公司不在范围内 -->

          <el-popover v-if="row.status == 2" placement="top-start" title="提示" width="200" trigger="hover" :content="getRowMsg(row)">
            <el-tag slot="reference" :type="getStatusTag(row.status).type">{{ getStatusTag(row.status).message }}</el-tag>
          </el-popover>

          <el-tag v-else :type="getStatusTag(row.status).type">{{ getStatusTag(row.status).message }}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="导入线下订单" :visible.sync="updateImportDialog" width="400px" append-to-body>
      <el-upload
        class="upload-demo"
        ref="upload"
        action=""
        :limit="1"
        accept=".csv,.xlsx,.xls"
        :multiple="false"
        :on-remove="handleRemove"
        :on-change="fileChange"
        :before-upload="beforeUpload"
        :before-remove="beforeRemove"
        :file-list="fileList"
        :auto-upload="false"
      >
        <!-- .xls格式：application/vnd.ms-excel .xlsx格式：application/vnd.openxmlformats-officedocument.spreadsheetml.sheet -->
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="onUpdateImport">上传到服务器</el-button>
        <!-- <el-button style="margin-left: 10px;" size="small" plain>模版下载</el-button> -->
        <el-link target="_blank" href="/assets/doc/导入模版.xls" style="margin-left: 20px;" size="small" plain>
          <i class="el-icon-download" />
          模版下载
        </el-link>

        <div slot="tip" class="el-upload__tip">
          只能上传xls/xlxs文件, 文件大小不超过10M
        </div>
      </el-upload>
    </el-dialog>
  </el-card>
</template>

<script>
import { importAddressParse, importOrder, importOrderItemParse, storeOrder } from '@/api/order-offline'
import { can } from '@/libs/utils'
import InputEdit from '@c/quick-edit/InputEdit'

export default {
  name: 'Form',
  components: {
    InputEdit,
  },

  data() {
    return {
      // 1 待处理 2 重复数据 3 商品解析异常 4 地址解析异常 5 上传中 6 上传成功 7 上传失败 8 数据不完整 9 快递公司不在范围内
      options: [
        {
          value: '1',
          label: '待处理',
        },
        {
          value: '2',
          label: '重复数据',
        },
        {
          value: '8',
          label: '数据不完整',
        },
        {
          value: '9',
          label: '快递公司不在范围内',
        },
        {
          value: '3',
          label: '商品解析异常',
        },
        {
          value: '4',
          label: '地址解析异常',
        },
        {
          value: '5',
          label: '上传中',
        },
        {
          value: '6',
          label: '上传成功',
        },
        {
          value: '7',
          label: '上传失败',
        },
      ],
      status: '',
      updateImportDialog: false, // 导入
      importForm: {},
      fileList: [],
      file: null,
      imports: [],
      allData: [],
      storeRow: 1,
    }
  },
  computed: {},
  created() {
    this.hasPermsDeliveryStatus = can('order.offline.delivery-status')
    this.hasPermsOrdersUpdate = can('order.offline.update')
  },
  methods: {
    // 1 待处理 2 重复数据 3 商品解析异常 4 地址解析异常 5 上传中 6 上传成功 7 上传失败 8 数据不完整 9 快递公司不在范围内
    getStatusTag(status) {
      let tag = {
        type: 'info',
        message: '待处理',
      }
      switch (status) {
        case 2:
          tag = {
            type: 'warning',
            message: '重复数据',
          }
          break
        case 8:
          tag = {
            type: 'warning',
            message: '数据不完整',
          }
          break
        case 9:
          tag = {
            type: 'warning',
            message: '快递公司不在范围内',
          }
          break
        case 3:
          tag = {
            type: 'warning',
            message: '商品解析异常',
          }
          break
        case 4:
          tag = {
            type: 'warning',
            message: '地址解析异常',
          }
          break
        case 5:
          tag = {
            type: 'default',
            message: '上传中',
          }
          break
        case 6:
          tag = {
            type: 'success',
            message: '上传成功',
          }
          break
        case 7:
          tag = {
            type: 'danger',
            message: '上传失败',
          }
          break
        default:
          break
      }
      return tag
    },

    async jumpImportOffline() {
      this.updateImportDialog = true
    },

    /** 文件预上传格式限制 */
    beforeUpload(file) {
      // 文件类型
      const isType = file.type === 'application/vnd.ms-excel'
      const isTypeComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const fileType = isType || isTypeComputer
      if (!fileType) {
        this.$message.error('上传文件只能是xls/xlsx格式！')
      }

      // 文件大小限制为10M
      const fileLimit = file.size / 1024 / 1024 < 10
      if (!fileLimit) {
        this.$message.error('上传文件大小不超过10M！')
      }
      return fileType && fileLimit
    },

    /** 文件移除时 */
    handleRemove(file, fileList) {
      this.fileList = fileList
    },

    // 文件改变时
    fileChange(file, fileList) {
      this.fileList = fileList
      this.file = file
    },

    // 文件移除之前
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },

    async onUpdateImport() {
      if (this.allData.length > 0) {
        this.$confirm('存在未处理完的订单数据,本地数据将会覆盖,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            await this.importOrderFile()
            this.$message({
              type: 'success',
              message: '导入成功!',
            })
          })
          .catch(err => {
            console.log('err:', err)
          })
      } else {
        await this.importOrderFile()
      }
    },

    async importOrderFile() {
      console.log('fileList:', this.fileList)
      console.log('this.file:', this.file)

      const formData = new FormData()
      formData.append('file', this.file.raw)

      // debugger
      console.log('formData:', formData)

      const {
        data: { data },
      } = await importOrder(formData).setConfig({
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      console.log(data)

      localStorage.setItem('LOCAL_EXCEL', JSON.stringify(data))

      this.imports = data
      this.allData = data
      this.file = null
      this.fileList = []
      this.updateImportDialog = false
    },

    // 解析收获地址
    async updateImportShipRow(id, data) {
      const that = this
      console.log('data.ship_addr:', data.ship_addr)
      if (data.ship_addr.trim() === '') {
        that.$message({
          message: '序号为：' + id + '；收获地址信息缺失，该信息重置',
          type: 'warning',
        })
        that.loadData()
        return false
      }

      console.log(id, data)
      const res = await importAddressParse({ ship_addr: data.ship_addr })
      console.log('res', res)
      if (res.data.code == '200') {
        that.imports[id - 1]['shop_info'] = res.data.data.shop_info
        that.imports[id - 1]['status'] = res.data.data.status

        // 更新本地
        that.refreshLocalData()
      } else {
        that.$notify({
          title: '错误',
          message: res.data.msg,
          type: 'error',
        })
      }
    },

    // 解析订单信息
    async updateImportItemRow(id, data) {
      const that = this

      if (data.order_items.trim() == '') {
        that.$message({
          message: '序号为：' + id + '；订单信息缺失，该信息重置',
          type: 'warning',
        })
        that.loadData()
        return false
      }

      console.log(id, data)
      const res = await importOrderItemParse({ order_items: data.order_items })
      console.log('res', res)
      if (res.data.code == '200') {
        that.imports[id - 1]['order_data'] = res.data.data.order_data
        that.imports[id - 1]['total_amount'] = res.data.data.total_amount
        that.imports[id - 1]['final_amount'] = res.data.data.final_amount
        that.imports[id - 1]['status'] = res.data.data.status

        // 更新本地
        that.refreshLocalData()
      } else {
        that.$notify({
          title: '错误',
          message: res.data.msg,
          type: 'error',
        })
      }
    },

    async onSubmitOrders() {
      const that = this
      for (var i = 0; i < that.imports.length; i++) {
        const item = that.imports[i]

        console.log('item', item)
        if (item.status === 6) {
          continue
        } else if (item.status === 2 || item.status === 3 || item.status === 4 || item.status === 9 || item.status === 8) {
          that.$notify({
            title: '错误',
            message: '序号【' + item.num + '】不满足要求，跳过导入；',
            type: 'warning',
          })
          continue
        }

        that.storeRow = item.num

        // 默认 1 待处理 2 重复数据 3 商品解析异常 4 地址解析异常 5 上传中 6 上传成功 7 上传失败 8 数据不完整 9 快递公司不在范围内
        that.imports[i].status = 5

        const form = {
          id: 0,
          title: '',
          item_num: 0,
          pick_up_order: '',

          ship_name: item['shop_info']['ship_name'],
          ship_mobile: item['shop_info']['ship_mobile'],
          ship_area: item['shop_info']['ship_area'],
          ship_aera_code: item['shop_info']['ship_aera_code'],
          ship_addr: item['shop_info']['ship_addr'],
          memo: item['memo'],
          mark_text:
            item['order_time'] +
            '$$' +
            item['express_no'] +
            '$$' +
            item['express_company_name'] +
            '$$' +
            item['order_items'] +
            '$$' +
            item['ship_addr'],
          order_time: item['order_time'],

          items: item['order_data'],

          total_amount: item['total_amount'],
          final_amount: item['final_amount'],

          express_company_code: item['express_company_code'],
          express_company_name: item['express_company_name'],
          express_no: item['express_no'],
        }
        console.log('form:', form)

        const res = await storeOrder(form)
        console.log(res)
        if (res.status === 201) {
          that.imports[i].status = 6
          that.$notify({
            title: '成功',
            message: '序号【' + item.num + '】导入订单数据成功',
            type: 'success',
          })
        } else {
          that.imports[i].status = 7
          that.$notify({
            title: '错误',
            message: '序号【' + item.num + '】导入失败；原因:' + res.data.msg,
            type: 'error',
          })
        }
      }
      // 更新本地
      that.refreshLocalData()
    },

    refreshLocalData() {
      const that = this

      that.allData.forEach(item => {
        const filter_data = that.imports.filter(function(fItem, index) {
          return fItem.num === item.num
        })
        if (filter_data.length > 0) {
          item.status = filter_data[0].status
        }
      })

      console.log(that.allData)

      localStorage.setItem('LOCAL_EXCEL', JSON.stringify(that.allData))
    },

    loadData() {
      const data = localStorage.getItem('LOCAL_EXCEL')
      if (data) {
        this.imports = JSON.parse(data)
        this.allData = JSON.parse(data)
      }
    },

    getRowMsg(row) {
      console.log(row.existsRow)
      if (!row.existsRow[0]) {
        return ''
      }
      return '数据与序号【' + row.existsRow[0] + '】重复'
    },
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.loadData()
      },
      immediate: true,
    },
    status: {
      handler(newVal) {
        const that = this
        console.log('newVal:', newVal)
        if (newVal === '') {
          that.imports = that.allData
          return true
        }
        const filter_data = that.allData.filter(function(item, index) {
          console.log(item.status, newVal.toString, item.status.toString === newVal.toString)
          return item.status == newVal
        })
        that.imports = filter_data
      },
      immediate: true,
    },
  },
}
</script>

<style scoped lang="scss"></style>
